

const theme = {
  colors: {
    primary: "#1D4ED8",      // Banking Blue (buttons, highlights)
    secondary: "#111827",    // Sidebar / Dark navigation
    accent: "#D4AF37",       // Gold (finance highlight)

    background: "#F3F4F6",   // Main background
    surface: "#FFFFFF",      // Cards / panels

    textPrimary: "#111827",  // Main text
    textSecondary: "#6B7280", // Secondary text

    border: "#E5E7EB",

    success: "#16A34A",      // Profit / paid
    warning: "#F59E0B",      // Due soon
    danger: "#DC2626",       // Overdue loans
    info: "#0284C7"          // info / charts
  },

  spacing: {
    padding: "16px",
    radius: "10px",
  },

  shadow: "0 6px 16px rgba(0,0,0,0.08)",
};

export default theme;